import { makeAutoObservable } from "mobx";

// Shared "last used" server + period so switching tabs doesn't reset the
// user back to defaults every time — persisted to localStorage (per-browser,
// not synced across devices) rather than the backend, since it's a pure UI
// convenience, not data anyone else needs to see.
const STORAGE_KEY = "dash:periodPrefs";

function load() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

class PeriodPrefsStore {
  selectedServer = "";
  fromDate = "";
  toDate = "";
  quickRange = "week";

  constructor() {
    makeAutoObservable(this);
    const saved = load();
    this.selectedServer = saved.selectedServer || "";
    this.fromDate = saved.fromDate || "";
    this.toDate = saved.toDate || "";
    this.quickRange = saved.quickRange || "week";
  }

  persist() {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          selectedServer: this.selectedServer,
          fromDate: this.fromDate,
          toDate: this.toDate,
          quickRange: this.quickRange,
        }),
      );
    } catch {
      // Private browsing / blocked storage — the app still works, it just
      // won't remember across reloads.
    }
  }

  setServer(id) {
    this.selectedServer = String(id ?? "");
    this.persist();
  }

  setPeriod(from, to, quickRange = "") {
    this.fromDate = from;
    this.toDate = to;
    this.quickRange = quickRange;
    this.persist();
  }
}

const periodPrefsStore = new PeriodPrefsStore();
export default periodPrefsStore;
